import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import { TerminalRegionActions } from '@/common/enums/TerminalRegionActions'

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    terminalRegions: {
      type: Array,
      default: () => []
    },

    approveForm: {
      type: Object,
      default: () => ({})
    },

    errors: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    isGkoOrganizationSubject() {
      return this.form.organization.subject_id === OrganizationSubjects.Gko
    },

    terminalRegion() {
      return this.terminalRegions.find(region => region.id === this.form.application.terminal_region_id);
    },

    hasTransportAccess() {
      return TerminalRegionActions.transportConditions[this.terminalRegion?.transport_access] ?? false
    }
  },

  methods: {
    async givePdfPass(isGivePassPeriod, printPermanentAsOne) {
      const pdfPassBlobResponse = await ApiClient.getPass(
        this.form.application.id,
        this.visitor.personal.id,
        this.visitor.transports[this.transportIndex]?.id ?? '',
        isGivePassPeriod ?? false,
        printPermanentAsOne ?? false
      )
      this.openPdfInNewTab(pdfPassBlobResponse.data)
    },

    openPdfInNewTab(pdfPassBlob) {
      window.open(
        URL.createObjectURL(pdfPassBlob),
        '_blank'
      )
    }
  }
}
